<template>
  <div class="user-center__requirement-container user-center__common-child-container">
    <sub-page-header>
      <template #title>
        <router-link tag="div" :to="nav.url" active-class="active" class="title__front-item"
          v-for="(nav, index) in breadcrumbs" :key="index">{{ nav.name }}</router-link>
      </template>
      <template #bt>
        <router-link tag="div" :to="{
          path: '/my/requirement/create'
        }" class="bt-item">发布需求</router-link>
      </template>
    </sub-page-header>
    <div class="requirement__main-body">
      <template v-if="items.length > 0">
        <div class="main-body__item" v-for="(item, index) in items" :key="index">
          <div class="item__wrapper" @click.stop.prevent="godetail(item.id)">
            <div class="item__info">
              <div class="info__content">
                <span>{{ item.mold_name }}_</span>{{ item.content }}
              </div>
              <div class="info__others">
                <p class="others__created">{{ item.ctime | parseTime }}</p>
                <p class="others__views">
                  <i class="views__icon icon icon-view"></i>{{ item.browsenums }}
                </p>
              </div>
              <el-button class="info__bts" :disabled="item.status === 2" :class="{
                '--submit': item.status === 0,
                '--done': item.status === 2
              }" @click.stop.prevent="item.status === 0 && requirementDone(item.id)">
                {{ item.status === 0 ? "点击已解决" : item.status === 2 ? "需求已解决" : "" }}
              </el-button>
            </div>
            <div class="item__covers">
              <div class="covers__container" v-if="item.picture_urls">
                <div class="coves__item" v-for="(img, index) in item.picture_urls" :key="index">
                  <el-image :preview-src-list="item.picture_urls | parseImage" class="img" fit="cover"
                    :src="img | parseImage"></el-image>
                </div>
              </div>
              <div class="cover_template">
                <el-button class="info__bts" type="success" v-if="item.report_url" @click.stop="onPreview"
                  :data-url="item.report_url | parseImage">材料报告</el-button>
                <div class="covers__status" :class="{
                  '--requesting': item.status === 0,
                  '--required': item.status === 2
                }">
                  {{ item.status === 0 ? "需求进行中" : item.status === 2 ? "需求已完成" : "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <empty v-else hint="暂无需求"></empty>
      <pagination class="component-pagination" v-if="paginationConfig" :config="paginationConfig"></pagination>
    </div>
  </div>
</template>

<script>
import { myRequirements, requirementDone } from '@/api/requirement';
import Empty from '@/pages/common/empty.vue';
import Pagination from '@/components/pagination.vue';
import SubPageHeader from '../_pageHeader.vue';

export default {
  components: {
    SubPageHeader,
    Empty,
    Pagination,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '我的需求',
          url: '/my/requirements',
        },
      ],
      items: [],
      pageSize: 9,
      paginationConfig: null,
    };
  },
  computed: {
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    init() {
      // 获取列表
      this.getMyRequirements();
    },
    async getMyRequirements() {
      this.$store.commit('openLoading');
      const res = await myRequirements({
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.items = data.list;
      this.paginationConfig = data.total.num > 0 ? data.total : null;
      this.$store.commit('closeLoading');
    },
    requirementDone(id) {
      const that = this;
      that
        .$confirm('确定解决该需求', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '解决',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            const tempIns = instance;
            if (action === 'confirm') {
              tempIns.confirmButtonLoading = true;
              tempIns.confirmButtonText = '完成中...';
              requirementDone({ id }).then(() => {
                tempIns.confirmButtonText = '确定';
                tempIns.confirmButtonLoading = false;
                that.items.map((item) => {
                  const temp = item;
                  temp.status = temp.id === id ? 2 : temp.status;
                  return temp;
                });
                done();
              });
            } else {
              done();
            }
          },
        })
        .then(() => {
          that.$message({
            type: 'success',
            message: '需求已完成',
          });
        });
    },
    godetail(id) {
      this.$router.push({
        path: `/requirement/${id}`,
      });
    },
    onPreview(e) {
      const url = e.currentTarget.dataset.url
      window.open(url)
    }
  },
};
</script>

<style></style>
